export default "__VITE_ASSET__BHBeULY1__"